import type { SVGProps } from 'react';

export const ChevronLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M14.804 3.25168C15.079 2.91431 15.5232 2.91641 15.7963 3.2562C16.0694 3.59599 16.0677 4.14482 15.7926 4.48219L9.69341 11.9635L15.7506 19.5227C16.0231 19.863 16.0205 20.413 15.7451 20.7498C15.4697 21.0861 15.0253 21.0829 14.7528 20.743L8.20309 12.5686C8.20158 12.5667 8.20002 12.5648 8.19852 12.5629C7.93099 12.2228 7.93397 11.6789 8.20675 11.3437L14.804 3.25168Z" />
  </svg>
);
